import { Button, Flex } from 'antd';
import type { FC, JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@shared/ui/antd';
import {
  Avito,
  ChannelTelegram,
  ChannelVk,
  ChannelWidget,
  CreatorMax,
} from '@shared/assets/icons/components';
import type { ChannelCreatableType } from '@modules/channels/lib/channel-type';
import styles from './channel-type-cards.module.scss';

interface ChannelTypeCardsProps {
  onSelect: (type: ChannelCreatableType) => void;
}

const CHANNEL_TYPES: ChannelCreatableType[] = [
  'widget',
  'telegram_bot',
  'telegram',
  'vk_bot',
  'max_bot',
  'avito',
];

const CHANNEL_TYPE_ICONS: Record<ChannelCreatableType, JSX.Element> = {
  widget: <ChannelWidget width={48} height={48} />,
  telegram_bot: <ChannelTelegram width={48} height={48} />,
  telegram: <ChannelTelegram width={48} height={48} />,
  vk_bot: <ChannelVk width={48} height={48} />,
  max_bot: <CreatorMax width={48} height={48} />,
  avito: <Avito width={48} height={48} className={styles.avitoIcon} />,
};

export const ChannelTypeCards: FC<ChannelTypeCardsProps> = ({ onSelect }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'channels' });

  const filteredChannelTypes = CHANNEL_TYPES.filter((type) => type !== 'telegram');

  return (
    <Flex gap={16} wrap="wrap" className={styles.list}>
      {filteredChannelTypes.map((channelType) => (
        <Flex key={channelType} vertical align="center" className={styles.card}>
          <div className={styles.icon}>{CHANNEL_TYPE_ICONS[channelType]}</div>

          <Text variant="sm" fontWeight={500} className={styles.title}>
            {t(`channelType.${channelType}`)}
          </Text>

          <Button type="default" className={styles.action} onClick={() => onSelect(channelType)}>
            {t('setupAction')}
          </Button>
        </Flex>
      ))}
    </Flex>
  );
};
